document.addEventListener("DOMContentLoaded", function () {
  // Handle tab click
  document.querySelectorAll('.faq-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const tabId = tab.dataset.tab;

      document.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.faq-content').forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      document.querySelector('.faq-content[data-tab-content="' + tabId + '"]').classList.add('active');
    });
  });

  // Handle accordion toggle with auto-close
  document.querySelectorAll('.faq-content').forEach(container => {
    container.addEventListener('click', function (e) {
      const clickedHeader = e.target.closest('.accordion-question');
      if (!clickedHeader) return;

      const allItems = container.querySelectorAll('.accordion-item');
      const currentItem = clickedHeader.parentElement;

      allItems.forEach(item => {
        if (item !== currentItem) {
          item.classList.remove('open');
        }
      });

      currentItem.classList.toggle('open');
    });
  });
});